import { Component, Prop, Vue } from "vue-property-decorator";
import WithRender from "./RequestsOverviewPage.html";
import { Inject } from "vue-di-container";
import UserService from "@/shared/userService/UserService";
import RequestsOverviewService from "./RequestsOverviewService";
import AllRequestsChart from "./components/AllRequestsChart";
import DelayedRequestsChart from "./components/DelayedRequestsChart";
import KPICards from "./components/KPICards";
import RequestTimelineChart from "./components/RequestTimelineChart";
import TimelineByCustomerTypeChart from "./components/TimelineByCustomerTypeChart";

@WithRender
@Component({
  components: { KPICards, AllRequestsChart, RequestTimelineChart, TimelineByCustomerTypeChart, DelayedRequestsChart },
  diProvide: [UserService, RequestsOverviewService],
})
export default class RequestsOverviewPage extends Vue {
  @Inject(UserService) public userService!: UserService;
  @Inject(RequestsOverviewService)
  public requestsOverviewService!: RequestsOverviewService;

  @Prop({ required: true }) public filter!: any;
  @Prop({ required: false, default: function () { return []; } }) public tenants!: any[];
  private refreshPromise: Promise<void> | null = null;

  public async refresh(): Promise<void> {
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    const orderedRefs = [
      "kpiCards",
      "allRequestsChart",
      "requestTimelineChart",
      "timelineByCustomerTypeChart",
      "delayedRequestsChart",
    ];

    this.refreshPromise = (async () => {
      await Promise.all(orderedRefs.map((refName) => this.refreshChildByRef(refName)));
    })();

    try {
      await this.refreshPromise;
    } finally {
      this.refreshPromise = null;
    }
  }

  private async refreshChildByRef(refName: string): Promise<void> {
    const component: any = this.$refs[refName];
    if (component && component.refresh) {
      await component.refresh();
    }
  }
}